import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import Vue from 'vue'
import store from '@/store'
import _ from 'lodash'

function tryRegisterSentry() {
  const appConfig = store.getters.configuration
  if(appConfig.enableSentry && appConfig.ravenClientDsn && process.env.NODE_ENV === 'production') {
    Sentry.init({
      beforeSend(event) {
        event.extra.token = _.get(store.getters, 'authenticationData.accessToken')
        return event
      },
      dsn: appConfig.ravenClientDsn,
      integrations: [
        new Integrations.Vue({
          Vue,
          attachProps: true
        })
      ]
    })
  }
}

export { tryRegisterSentry }
